export default __webpack_public_path__ + "static/media/redcube.092b4e52.svg";